import { Component, HostListener, EventEmitter, Output } from '@angular/core';
import { ResponsiveService } from '../../../../_services/responsive.service';
import { CiamService } from '../../../../_services/ciam.service';
import { LoginContextEnum } from '../login.component';

@Component({
  selector: 'ng-casto-customer-create-card-info',
  templateUrl: './create-card-info.component.html'
})
export class CustomerCreateCardInfoComponent {
  @Output() switchContext = new EventEmitter<LoginContextEnum>();

  loading = false;

  protected readonly LoginContext = LoginContextEnum;

  constructor(public responsive: ResponsiveService, private readonly ciamService: CiamService) {}

  /** Revenu par « Précédent », le navigateur restaure la page telle qu'on l'a quittée, bouton en chargement compris. */
  @HostListener('window:pageshow', ['$event'])
  onPageShow(event: PageTransitionEvent): void {
    if (event.persisted) {
      this.loading = false;
    }
  }

  onSwitchContext(loginContext: LoginContextEnum) {
    this.switchContext.emit(loginContext);
  }

  createCard(): void {
    this.loading = true;
    this.ciamService.redirectToRegister('/creation');
  }
}
